import { useSearchParams } from "react-router-dom";
import { SavedViews, type SavedView } from "../../components/SavedViews";
import { StatusBadge } from "../../components/StatusBadge";
import { ArchivePage } from "../archive/ArchivePage";

type ContentView = "archive" | "lookbook";

export function ContentPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeView = normalizeContentView(searchParams.get("view"));
  const contentViews: SavedView[] = [
    { key: "archive", label: "Archive" },
    { key: "lookbook", label: "룩북", count: 0 }
  ];

  return (
    <div className="page-stack">
      <section className="toolbar-panel">
        <SavedViews
          views={contentViews}
          active={activeView}
          onChange={(view) => {
            const next = new URLSearchParams(searchParams);
            if (view === "archive") next.delete("view");
            else next.set("view", view);
            setSearchParams(next);
          }}
        />
        <p className="help-text">고객에게 보이는 브랜드 기록, 룩북, 캠페인 페이지 콘텐츠를 관리합니다.</p>
      </section>

      {activeView === "archive" ? (
        <ArchivePage />
      ) : (
        <LookbookContentPanel />
      )}

    </div>
  );
}

function LookbookContentPanel() {
  const items = [
    { label: "관리 범위", value: "시즌별 룩북, 캠페인 컷, 스타일링 세트" },
    { label: "Archive와 차이", value: "Archive는 글/기록 중심, 룩북은 이미지 묶음과 상품 연결 중심" },
    { label: "다음 작업", value: "룩북 스키마, 대표 이미지, 연결 상품 규칙 확정" }
  ];
  return (
    <section className="panel">
      <div className="panel-head">
        <div>
          <h2>룩북</h2>
          <p>이미지 묶음과 상품 연결을 중심으로 고객이 탐색하기 좋은 콘텐츠를 준비합니다.</p>
        </div>
        <StatusBadge tone="info">준비 중</StatusBadge>
      </div>
      <div className="sync-list">
        {items.map((item) => (
          <div className="sync-row" key={item.label}>
            <div>
              <strong>{item.label}</strong>
              <span>{item.value}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function normalizeContentView(view: string | null): ContentView {
  if (view === "lookbook") return view;
  return "archive";
}
